import styled from 'styled-components';

const Overlay = styled.div`
  align-items: center;
  background-color: rgba(34, 34, 34, 0.8);
  bottom: 0;
  display: flex;
  left: 0;
  justify-content: center;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 100000;
  overflow: scroll;
`;

export default Overlay;
